/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryemptyhint3Inputs */

const en_medialibraryemptyhint3 = /** @type {(inputs: Medialibraryemptyhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets you create with the AI Studio tools show up here.`)
};

const de_medialibraryemptyhint3 = /** @type {(inputs: Medialibraryemptyhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalte, die du mit den KI-Studio-Werkzeugen erstellst, erscheinen hier.`)
};

/**
* | output |
* | --- |
* | "Assets you create with the AI Studio tools show up here." |
*
* @param {Medialibraryemptyhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryemptyhint3 = /** @type {((inputs?: Medialibraryemptyhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryemptyhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryemptyhint3(inputs)
	return de_medialibraryemptyhint3(inputs)
});
export { medialibraryemptyhint3 as "mediaLibraryEmptyHint" }